import { createAction, createReducer } from "@reduxjs/toolkit"
import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"
import { api } from "./helpers/api"

// ACTIONS
const requested = createAction("googleCalendar/requested")
const received = createAction("googleCalendar/received")
const failed = createAction("googleCalendar/failed")
const accountAdded = createAction("googleCalendar/accountAdded")
const accountDeleted = createAction("googleCalendar/accountDeleted")
const googleAuthsReceived = createAction("googleCalendar/googleAuthsReceived")
const accountUpdated = createAction("googleCalendar/accountUpdated")

// INITIAL STATE
const initialState = {
  ...LOADING_INITIAL_STATE, // Use LOADING_INITIAL_STATE for consistent loading management
  accounts: [],
  googleAuths: [], // Add googleAuths to store the API response
  error: null
}

// REDUCER
const googleCalendarReducer = createReducer(initialState, {
  [requested.type]: (state) => {
    setRequested(state) // Set loading state to requested
  },
  [received.type]: (state, action) => {
    setReceived(state) // Set loading state to received
    state.accounts = action.payload
  },
  [failed.type]: (state, action) => {
    setFailed(state) // Set loading state to failed
    state.error = action.payload
  },
  [accountAdded.type]: (state, action) => {
    setReceived(state) // Ensure loading is marked as received
    state.accounts.push(action.payload)
  },
  [accountUpdated.type]: (state, action) => {
    setReceived(state) // Ensure loading is marked as received
    const updatedAccount = action.payload
    state.accounts = state.accounts.map((account) => (account.id === updatedAccount.id ? updatedAccount : account))
  },
  [accountDeleted.type]: (state, action) => {
    setReceived(state) // Ensure loading is marked as received
    state.accounts = state.accounts.filter((account) => account.id !== action.payload.id)
  },
  [googleAuthsReceived.type]: (state, action) => {
    setReceived(state) // Ensure loading is marked as received
    state.googleAuths = action.payload
  }
})

export default googleCalendarReducer

// PUBLIC ACTIONS
// Fetch Google Calendar accounts auths (GET)
export const fetchGoogleCalendarAuths = () =>
  api({
    url: "/guide/user_oauths/new",
    method: "get",
    onStart: requested.type,
    onSuccess: googleAuthsReceived.type,
    onError: failed.type
  })

// Fetch Google Calendar accounts (GET)
export const fetchGoogleCalendarAccounts = () =>
  api({
    url: "/guide/user_oauths",
    method: "get",
    onStart: requested.type,
    onSuccess: received.type,
    onError: failed.type
  })

// Add a new Google Calendar account (POST)
export const addGoogleCalendarAccount = (data) =>
  api({
    url: "/guide/user_oauths",
    method: "post",
    data,
    onStart: requested.type,
    onSuccess: accountAdded.type,
    onError: failed.type
  })

// Delete a Google Calendar account (DELETE)
export const deleteGoogleCalendarAccount = (accountId) =>
  api({
    url: `guide/user_oauths/${accountId}`,
    method: "delete",
    onStart: requested.type,
    onSuccess: accountDeleted.type,
    onError: failed.type,
    props: { showToast: false }
  })

// connect/disconnect a Google Calendar account (POST)
export const manageGoogleCalendarConnection = ({ accountId, active }) =>
  api({
    url: `guide/user_oauths/${accountId}/?active=${active}`,
    method: "patch",
    onStart: requested.type,
    onSuccess: accountUpdated.type,
    onError: failed.type,
    props: { showToast: false }
  })
